// extracted by mini-css-extract-plugin
module.exports = {"header-border":"Header_header-border__R_Aub","menu-item":"Header_menu-item__JRnBz","border-item":"Header_border-item__OXEKL","header":"Header_header__cHAAS"};